const local = {
  bookdemo: {
    Link: "https://agentsaif-bookdemo.stage.neuralcompany.team/saifaviator",
  },
};

const dev = {
  bookdemo: {
    Link: "https://agentsaif-bookdemo.stage.neuralcompany.team/saifaviator",
  },
};

const prod = {
  bookdemo: {
    Link: "https://demo.akira.ai/saifaviator/",
  },
};

const config =
  process.env.REACT_APP_STAGE === "production"
    ? prod
    : process.env.REACT_APP_STAGE === "development"
    ? dev
    : // : process.env.REACT_APP_STAGE === "uat"
      // ? uat
      local;
// eslint-disable-next-line
export default {
  ...config,
};
